import { dcFetch, dcFetchJson } from "./httpClient";
import { GlossaryEntry } from "./mockData";
import { ModelConfig } from "./translationService";
import { StoredSegmentState } from "./segmentSync";
export interface WorkspaceSettingsRecord {
  id?: number;
  glossary?: GlossaryEntry[];
  modelConfigs?: ModelConfig[];
  openRouterApiKey?: string;
}
export interface DocumentStateRecord {
  id?: number;
  documentPairKey: string;
  enTemplateId: number;
  frTemplateId?: number | null;
  segments?: StoredSegmentState[];
  draftCache?: Record<string, unknown>;
  manualSectionGroups?: Record<string, unknown>;
}
export async function fetchWorkspaceSettings(): Promise<WorkspaceSettingsRecord | null> {
  const response = await dcFetch("/dc-translation-workspace-settings");
  if (response.status === 404) return null;
  if (!response.ok) {
    const text = await response.text().catch(() => "");
    throw new Error(`API error: ${response.status} ${text.slice(0, 200)}`);
  }
  return response.json();
}
export async function saveWorkspaceSettings(data: WorkspaceSettingsRecord): Promise<WorkspaceSettingsRecord> {
  return dcFetchJson<WorkspaceSettingsRecord>("/dc-translation-workspace-settings", {
    method: "PUT",
    body: JSON.stringify(data)
  });
}
export async function fetchDocumentState(documentPairKey: string): Promise<DocumentStateRecord | null> {
  const params = new URLSearchParams({
    documentPairKey,
    _limit: "1"
  });
  const rows = await dcFetchJson<DocumentStateRecord[]>(`/dc-translation-document-states?${params}`);
  return rows[0] || null;
}
export async function fetchAllDocumentStates(): Promise<DocumentStateRecord[]> {
  return dcFetchJson<DocumentStateRecord[]>("/dc-translation-document-states?_limit=1000");
}
export async function upsertDocumentState(data: DocumentStateRecord): Promise<DocumentStateRecord> {
  return dcFetchJson<DocumentStateRecord>("/dc-translation-document-states/upsert", {
    method: "POST",
    body: JSON.stringify(data)
  });
}
export async function deleteDocumentState(id: number): Promise<void> {
  const response = await dcFetch(`/dc-translation-document-states/${id}`, {
    method: "DELETE"
  });
  if (!response.ok) {
    const text = await response.text().catch(() => "");
    throw new Error(`API error: ${response.status} ${text.slice(0, 200)}`);
  }
}